import { create } from "zustand";
import { AppSlice, createAppSlice } from "./createAppSlice";
import { createMenuSlice, MenuSlice } from "./createMenuSlice";
import { createOrdersSlice, OrderSlice } from "./createOrdersSlcie";
type CombinedSlice = AppSlice & MenuSlice & OrderSlice;
export const indexStore = create<CombinedSlice>()((...a) => ({
  ...createAppSlice(...a),
  ...createMenuSlice(...a),
  ...createOrdersSlice(...a),
}));
